import { useState } from 'react';

/**
 * Ejecuta `alCambiar` durante el render cuando cambia `clave` (y en el primer render), en vez de
 * en un efecto: es el patrón de React para reiniciar estado derivado de props o del contexto.
 * `alCambiar` solo debe llamar setters de estado.
 */
export function useAlCambiarClave(clave: string, alCambiar: () => void): void {
  const [claveVista, setClaveVista] = useState<string | null>(null);
  if (claveVista !== clave) {
    setClaveVista(clave);
    alCambiar();
  }
}
